import { useEffect, useRef } from 'react'

import useAnalytics from '@/context/analytics'
import { useNavigation } from '@/context/navigationContext'

type Props = {
  title?: string
}

export const TrackPage: React.FC<Props> = ({ title }) => {
  const hasTriggerPageView = useRef(false) // prevent multiple fires on the same page

  const { currentNavItem } = useNavigation() || {}
  const { pageViewed } = useAnalytics()

  const pageTitle = title ?? currentNavItem?.title

  useEffect(() => {
    if (pageTitle && !hasTriggerPageView.current) {
      hasTriggerPageView.current = true
      pageViewed(pageTitle)
    }
  }, [pageTitle, pageViewed])

  return null
}
